




































import { mapState } from "vuex";
import PointNotificationPanelSmall from "@/general/components/molecules/PointNotificationPanelSmall.vue";
import CONST_DATA from "@/general/mixins/const/constData";
import IconNotificationThanks from "@/common/components/icons/IconNotificationThanks.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";

import { Prop, Vue, Component } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";

@Component({
  components: {
    PointNotificationPanelSmall,
    IconNotificationThanks,
    IconUserImage
  },
  filters: {
    addComma(value: any) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
  }
})
export default class A01PointNotificationPanelThanks extends Vue {
  @Prop({ type: Object, required: true }) giver!: any;
  @Prop({ type: Number, required: true }) point!: number;
  @Prop({ type: String, required: true }) url!: string;

  isSpScreenWidth = commons.isSpScreenWidth;

  get unit() {
    return commons?.OrgPageSpecific?.point_name;
  }

  get iconSize() {
    const iconSize = {
      sp: 28,
      pc: 32
    };
    const index = this.isSpScreenWidth ? "sp" : "pc";
    return iconSize[index];
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }
}
